'use client'

import { useQuery } from '@tanstack/react-query'

import { useAuthInfo } from '@sweetauth/core'

import { fetchPerson } from '@/context/usaspending'

import type { PersonProfile } from '@/types/usaspending'

import { usaspendingKeys } from './queryKeys'
import { assertToken } from './utils'

/**
 * Hook to fetch person profile details
 *
 * @param id - The person ID
 * @param options.enabled - Whether to enable the query (default: true)
 */
export function usePerson(id: string, options: { enabled?: boolean } = {}) {
  const { enabled = true } = options
  const { accessToken } = useAuthInfo()

  return useQuery<PersonProfile>({
    queryKey: usaspendingKeys.personDetail(id),
    queryFn: () => fetchPerson(assertToken(accessToken), id),
    enabled: enabled && !!id && !!accessToken,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
